module.exports = __webpack_public_path__ + "static/media/checkmark.1235c2e3.svg";